import Content from './Content';

export default Content;
export * from './Content';
